import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AdminGuard } from 'app/services/admin.guard';
import { AuthGuard } from 'app/services/auth.guard';
import { EmailSubdomainGuard } from 'app/services/email-subdomain.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ExploreComponent } from './components/explore/explore.component';
import { PftCftScoresComponent } from './components/pft-cft-scores/pft-cft-scores.component';

const routes = [
  {
    path: 'explore',
    component: DashboardComponent,
    canActivate: [AuthGuard, EmailSubdomainGuard],
  },
  {
    path: 'explore/training-load-analysis',
    component: ExploreComponent,
    canActivate: [AuthGuard, EmailSubdomainGuard]
  },
  {
    path: 'explore/pft-cft-scores',
    component: PftCftScoresComponent,
    canActive: [AuthGuard, AdminGuard, EmailSubdomainGuard]
  }  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class ExploreRoutingModule { }
